import { AxiosError } from 'axios';

/**
 * Extracts a user-friendly error message from an API error response.
 * Handles field-specific errors (both string and array formats) and fallback messages.
 *
 * @param error - The error object (typically an AxiosError)
 * @param field - The field name that caused the error (optional)
 * @param defaultMessage - Default message to return if no error message is found
 * @returns A user-friendly error message string
 */
export function extractErrorMessage(
	error: unknown,
	field?: string,
	defaultMessage = 'An error occurred'
): string {
	if (error instanceof AxiosError && error.response?.data) {
		const errorData = error.response.data as Record<string, unknown>;

		if (field && field in errorData) {
			const fieldError = errorData[field];
			if (typeof fieldError === 'string') {
				return fieldError;
			}
			if (Array.isArray(fieldError) && fieldError.length > 0) {
				return String(fieldError[0]);
			}
		}

		if (typeof errorData === 'object' && 'message' in errorData) {
			return String(errorData.message);
		}
	}

	return defaultMessage;
}
